import { Button, Typography } from '@lamimed/pantheon';
import Image from 'next/legacy/image';

import * as S from './styles';

interface PrescriptionSuccessProps {
  onFinish: () => void;
}

export const PrescriptionSuccess: React.FC<PrescriptionSuccessProps> = ({
  onFinish,
}) => (
  <S.SuccessMessage>
    <Typography
      variant="heading_2"
      color="text__highlight"
      textAlign="center"
      marginBottom="medium"
    >
      Messaggio inviato con successo
    </Typography>

    <Image
      src="/images/illustration/prescription/prescription-success.svg"
      width={258}
      height={122}
      quality={100}
    />

    <Typography textAlign="center" marginTop="small" marginBottom="large">
      A breve ti invieremo un email con il link per prenotare
    </Typography>

    <Button variant="default" color="primary" extended onClick={onFinish}>
      Finito
    </Button>
  </S.SuccessMessage>
);
